import angular from 'angular'

import { workflowRoutes } from './workflow.routes'

import { archivedTasksService } from './services/archived-tasks.service'
import { boardColumnsService } from './services/board-columns.service'
import { boardsService } from './services/boards.service'
import { briefingService } from './services/briefing.service'
import { tasksService } from './services/tasks.service'
import { viewOptionService } from './services/view-option.service'
import { workflowHeaderService } from './services/workflow-header.service'
import { approvalsService } from './services/approvals.service'
import { taskTagsService } from './services/task-tags.service'
import { workflowService } from './services/workflow.service'

import { dateFilter } from './filters/filter-date.filter'
import { dateMediumFilter } from './filters/filter-medium-date.filter'
import { dateShortFilter } from './filters/filter-short-date.filter'
import { dateLongFilter } from './filters/filter-long-date.filter'
import { formattedStatusFilter } from './filters/format-status.filter'

import { confirmDeleteTaskDocumentDialogDirective } from './dialogs/confirm-delete-task-document/confirm-delete-task-document-dialog.directive'
import { archivedTasks } from './directives/archived-tasks/archived-tasks.directive'
import { boardItem } from './directives/board-item/board-item.directive'
import { changeBoards } from './directives/change-boards/change-boards.directive'
import { briefingInput } from './directives/briefing-input/briefing-input.directive'
import { kanbanTaskCard } from './directives/kanban-task-card/kanban-task-card.directive'
import { requestForm } from './directives/request-form/request-form.directive'
import { taskSimpleCard } from './directives/task-simple-card/task-simple-card.directive'
import { taskArchivedBadge } from './directives/task-archived-badge/task-archived-badge.directive'
import { workflowFiltersDirective } from './directives/workflow-filters/workflow-filters.directive'
import { statusBadgeDirective } from './directives/status-badge/status-badge.directive'
import { statusSelectDirective } from './directives/status-select/status-select.directive'
import { boardColumnDialog } from './dialogs/board-column/board-column-dialog.directive'
import { goBackDirective } from './directives/go-back/go-back.directive'
import { kanbanCardDate } from './directives/kanban-card-date/kanban-card-date.directive'
import { daysInColumn } from './directives/days-in-column/days-in-column.directive'
import { boardFormDialog } from './dialogs/board-form/board-form-dialog.directive'
import { moveTaskDialog } from './dialogs/move-task/move-task-dialog.directive'
import { moveAutomaticallyAlert } from './dialogs/move-automatically-alert/move-automatically-alert.directive'
import { moveTaskReviewDialog } from './dialogs/move-task-review/move-task-review-dialog.directive'
import { requestReviewDialogDirective } from './dialogs/request-review/request-review-dialog.directive'
import { rejectRequestDialog } from './dialogs/reject-request/reject-request-dialog.directive'
import { taskRatingStarsDirective } from './directives/task-rating-stars/task-rating-stars.directive'
import { acceptRequestDialogDirective } from './dialogs/accept-request/accept-request-dialog.directive'
import { createTaskDialogDirective } from './dialogs/create-task/create-task-dialog.directive'
import { acceptRemoveBoardColumnDialogDirective } from './dialogs/accept-remove-board-column-dialog/accept-remove-board-column-dialog.directive'
import { requestAdjustmentDialogDirective } from './dialogs/request-adjustment/request-adjustment-dialog.directive'
import { finishTaskAlertDialogDirective } from './dialogs/finish-task-alert/finish-task-alert-dialog.directive'
import { rateRequestDialogDirective } from './dialogs/rate-request/rate-request-dialog.directive'
import { archivingConfirmationRequestDialog } from './dialogs/archiving-confirmation-request/archiving-confirmation-request-dialog.directive'
import { changeRequesterDialogDirective } from './dialogs/change-requester/change-requester-dialog.directive'
import { attachmentList } from './directives/attachment-list/attachment-list.directive'
import { boardStatusAlertDialogDirective } from './dialogs/board-status-alert/board-status-alert-dialog.directive'
import { columnTag } from './directives/column-tag/column-tag.directive'
import { taskTagsInput } from './directives/task-tags-input/task-tags-input.directive'
import { cardTags } from './directives/card-tags/card-tags.directive'
import { subtaskSectionDirective } from './directives/subtasks-section/subtasks-section.directive'
import { subtaskItemDirective } from './directives/subtask-item/subtask-item.directive'
import { documentsSectionDirective } from './directives/documents-section/documents-section.directive'
import { documentItemDirective } from './directives/document-item/document-item.directive'
import { requestCard } from './directives/request-card/request-card.directive'
import { requestDetailsDialog } from './dialogs/request-details/request-details-dialog.directive'
import { subtaskDetailsDialog } from './dialogs/subtask-details/subtask-details-dialog.directive'
import { approvalStatus } from './directives/approval-status/approval-status.directive'
import { requestReviewApproval } from './dialogs/request-review-approval/request-review-approval-dialog.directive'
import { approvalFormDialogDirective } from './dialogs/approval-form/approval-form-dialog.directive'
import { saveTaskFilterDialog } from './dialogs/save-task-filter/save-task-filter-dialog.directive'
import { internalApprovalCard } from './directives/internal-approval-card/internal-approval-card.directive'
import { duplicateTaskDialog } from './dialogs/duplicate-task/duplicate-task-dialog.directive'
import { timesheetEditDialog } from './dialogs/timesheet-edit/timesheet-edit-dialog.directive'
import { timesheetRegisterDialog } from './dialogs/timesheet-register/timesheet-register-dialog.directive'
import { taskAssignees } from './directives/task-assignees/task-assignees.directive'
import { internalApprovalHistoryDirective } from './directives/internal-approval-history/internal-approval-history.directive'
import { marketingCalendar } from './directives/marketing-calendar/marketing-calendar.directive'
import { marketingCalendarEvent } from './directives/marketing-calendar-event/marketing-calendar-event.directive'
import { marketingCalendarList } from './directives/marketing-calendar-list/marketing-calendar-list.directive'
import { marketingCalendarCampaignsList } from './directives/marketing-calendar-campaigns-list/marketing-calendar-campaigns-list.directive'
import { requestsTab } from './directives/requests-tab/requests-tab.directive'
import { myApprovalsTab } from './directives/my-approvals-tab/my-approvals-tab.directive'
import { allTasksTab } from './directives/all-tasks-tab/all-tasks-tab.directive'

import { attachmentItem } from './components/attachment-item/attachment-item.component'
import { checkboxInput } from './components/checkbox-input/checkbox-input.component'
import { dateInput } from './components/date-input/date-input.component'
import { dropdownInput } from './components/dropdown-input/dropdown-input.component'
import { previewAttachment } from './components/preview-attachment/preview-attachment.component'
import { radioInput } from './components/radio-input/radio-input.component'
import { richTextInput } from './components/rich-text-input/rich-text-input.component'
import { simpleInput } from './components/simple-input/simple-input.component'
import { taskPriorityBadge } from './components/task-priority-badge/task-priority-badge.component'
import { taskStatusBadge } from './components/task-status-badge/task-status-badge.component'
import { taskStatusCard } from './components/task-status-card/task-status-card.component'
import { workflowAttachmentPreview } from './components/workflow-attachment-preview/workflow-attachment-preview.component'
import { timesheetService } from './services/timesheet.service'
import { dateMediumShortYearFilter } from './filters/filter-date-medium-short-year.filter'
import { timesheetTimeFilter } from './filters/filter-timesheet-time.filter'
import { timesheetTimeSpentFilter } from './filters/filter-timesheet-time-spent.filter'

const module = angular
  .module('deskfy.workflow', [])
  .config(workflowRoutes)
  .factory('ArchivedTasksService', archivedTasksService)
  .factory('BoardColumnsService', boardColumnsService)
  .factory('BoardsService', boardsService)
  .factory('BriefingService', briefingService)
  .factory('TasksService', tasksService)
  .factory('ViewOptionService', viewOptionService)
  .factory('WorkflowHeaderService', workflowHeaderService)
  .factory('ApprovalsService', approvalsService)
  .factory('TaskTagsService', taskTagsService)
  .factory('WorkflowService', workflowService)
  .factory('TimesheetService', timesheetService)
  .filter('dateFilter', dateFilter)
  .filter('dateMediumFilter', dateMediumFilter)
  .filter('dateMediumShortYearFilter', dateMediumShortYearFilter)
  .filter('dateShortFilter', dateShortFilter)
  .filter('dateLongFilter', dateLongFilter)
  .filter('formattedStatusFilter', formattedStatusFilter)
  .filter('timesheetTimeFilter', timesheetTimeFilter)
  .filter('timesheetTimeSpentFilter', timesheetTimeSpentFilter)
  .directive('briefingInput', briefingInput)
  .directive('archivedTasks', archivedTasks)
  .directive('kanbanTaskCard', kanbanTaskCard)
  .directive('requestForm', requestForm)
  .directive('taskSimpleCard', taskSimpleCard)
  .directive('boardItem', boardItem)
  .directive('boardFormDialog', boardFormDialog)
  .directive('moveAutomaticallyAlert', moveAutomaticallyAlert)
  .directive('moveTaskReviewDialog', moveTaskReviewDialog)
  .directive('taskArchivedBadge', taskArchivedBadge)
  .directive('workflowFilters', workflowFiltersDirective)
  .directive('statusBadge', statusBadgeDirective)
  .directive('boardColumnDialog', boardColumnDialog)
  .directive('moveTaskDialog', moveTaskDialog)
  .directive('goBack', goBackDirective)
  .directive('changeBoards', changeBoards)
  .directive('taskRatingStars', taskRatingStarsDirective)
  .directive('acceptRequestDialog', acceptRequestDialogDirective)
  .directive('createTaskDialogDirective', createTaskDialogDirective)
  .directive('acceptRemoveBoardColumnDialog', acceptRemoveBoardColumnDialogDirective)
  .directive('requestAdjustmentDialog', requestAdjustmentDialogDirective)
  .directive('requestReviewDialog', requestReviewDialogDirective)
  .directive('finishTaskAlertDialog', finishTaskAlertDialogDirective)
  .directive('boardStatusAlertDialogDirective', boardStatusAlertDialogDirective)
  .directive('rateRequestDialog', rateRequestDialogDirective)
  .directive('archivingConfirmationRequestDialog', archivingConfirmationRequestDialog)
  .directive('rejectRequestDialog', rejectRequestDialog)
  .directive('changeRequesterDialog', changeRequesterDialogDirective)
  .directive('kanbanCardDate', kanbanCardDate)
  .directive('daysInColumn', daysInColumn)
  .directive('attachmentList', attachmentList)
  .directive('columnTag', columnTag)
  .directive('taskTagsInput', taskTagsInput)
  .directive('cardTags', cardTags)
  .directive('subtaskSection', subtaskSectionDirective)
  .directive('subtaskItem', subtaskItemDirective)
  .directive('requestCard', requestCard)
  .directive('requestDetailsDialog', requestDetailsDialog)
  .directive('subtaskDetailsDialog', subtaskDetailsDialog)
  .directive('approvalFormDialog', approvalFormDialogDirective)
  .directive('saveTaskFilterDialog', saveTaskFilterDialog)
  .directive('statusSelect', statusSelectDirective)
  .directive('approvalStatus', approvalStatus)
  .directive('requestReviewApprovalDialog', requestReviewApproval)
  .directive('internalApprovalCard', internalApprovalCard)
  .directive('duplicateTaskDialog', duplicateTaskDialog)
  .directive('timesheetEditDialog', timesheetEditDialog)
  .directive('timesheetRegisterDialog', timesheetRegisterDialog)
  .directive('taskAssignees', taskAssignees)
  .directive('internalApprovalHistory', internalApprovalHistoryDirective)
  .directive('marketingCalendar', marketingCalendar)
  .directive('marketingCalendarEvent', marketingCalendarEvent)
  .directive('marketingCalendarList', marketingCalendarList)
  .directive('marketingCalendarCampaignsList', marketingCalendarCampaignsList)
  .directive('requestsTab', requestsTab)
  .directive('myApprovalsTab', myApprovalsTab)
  .directive('allTasksTab', allTasksTab)
  .directive('documentsSection', documentsSectionDirective)
  .directive('documentItem', documentItemDirective)
  .directive('confirmDeleteTaskDocumentDialog', confirmDeleteTaskDocumentDialogDirective)
  .component('attachmentItem', attachmentItem)
  .component('checkboxInput', checkboxInput)
  .component('dateInput', dateInput)
  .component('dropdownInput', dropdownInput)
  .component('previewAttachment', previewAttachment)
  .component('radioInput', radioInput)
  .component('richTextInput', richTextInput)
  .component('simpleInput', simpleInput)
  .component('taskPriorityBadge', taskPriorityBadge)
  .component('taskStatusBadge', taskStatusBadge)
  .component('taskStatusCard', taskStatusCard)
  .component('workflowAttachmentPreview', workflowAttachmentPreview)

export const workflowModule = module
